export default __webpack_public_path__ + "static/media/865.39408e6c.png";